import { render, staticRenderFns } from "./SalarySchemes.vue?vue&type=template&id=8ab5dcd0&"
import script from "./SalarySchemes.vue?vue&type=script&lang=js&"
export * from "./SalarySchemes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports